var map = {
	"./chatgpt.png": "b2ef",
	"./dalle.png": "221f",
	"./faceswap.png": "5d0b",
	"./midjourney.png": "6057",
	"./pika.png": "cc2f",
	"./runway.png": "33bf",
	"./stable-diffusion.png": "7188",
	"./yandex.png": "3ff31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e77";